import { Container, Sprite } from "pixi.js";
import { HBox } from "../../../common/components/ui/HBox";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";

export class CheckoutPiggyDescriptionComponent extends Container {
    private readonly contentBox: HBox;
    private readonly arrow: Sprite;
    protected readonly descriptionContent: Container;

    public constructor(commonResources: CommonResourcesPackage) {
        super();
        this.contentBox = new HBox(13);
        this.addChild(this.contentBox);
        this.arrow = new Sprite(commonResources.assets_common_ui_back_png);
        this.arrow.width = 23;
        this.arrow.height = 36;
        this.arrow.position.y = 5;
        this.descriptionContent = new Container();
        this.contentBox.addChild(this.arrow, this.descriptionContent);
    }
}